import { useRef, useEffect } from "react";
import axios from "axios";

export function useHandRaise({ API, code, me, players, setMe, setPlayers }) {
  const handAudioRef = useRef(null);
  const prevPlayersRef = useRef([]);
  const lastBeepAtRef = useRef(0);

  useEffect(() => {
    handAudioRef.current = new Audio("/sounds/hand.mp3");
    handAudioRef.current.volume = 0.6;
    handAudioRef.current.preload = "auto";
  }, []);

  const myHandRaised = !!players.find(p => p.id === me?.id)?.handRaised;

  const toggleHandRaise = async () => {
    if (!me?.id) return;
    const next = !myHandRaised;
    setPlayers(prev => prev.map(p => p.id === me.id ? { ...p, handRaised: next } : p));
    setMe(prev => prev ? { ...prev, handRaised: next } : prev);
    try {
      await axios.patch(`${API}/api/players/${me.id}/hand`, { handRaised: next });
    } catch {
      setPlayers(prev => prev.map(p => p.id === me.id ? { ...p, handRaised: !next } : p));
      setMe(prev => prev ? { ...prev, handRaised: !next } : prev);
    }
  };

  // Appelé depuis fetchAll pour détecter les nouvelles mains levées et jouer le son
  const detectNewHandRaises = async (nextPlayers, playerId) => {
    const prevPlayers = prevPlayersRef.current;
    prevPlayersRef.current = nextPlayers;
    if (prevPlayers.length === 0) return;

    const prevById = new Map(prevPlayers.map(p => [p.id, p]));
    const newlyRaised = nextPlayers.filter(p => {
      if (p.id === playerId) return false;
      const prev = prevById.get(p.id);
      return prev && !prev.handRaised && p.handRaised;
    });

    if (newlyRaised.length > 0) {
      const now = Date.now();
      if (now - (lastBeepAtRef.current || 0) > 800) {
        lastBeepAtRef.current = now;
        try {
          if (handAudioRef.current) {
            handAudioRef.current.currentTime = 0;
            await handAudioRef.current.play();
          }
        } catch { }
      }
    }
  };

  return { myHandRaised, toggleHandRaise, detectNewHandRaises };
}